import axios from "axios";

export const actions = {
    PrintReport(context, data){
        return axios.get(`${data}`, {responseType: 'blob'});
    },
    PrintReportPost(context, data){
        return axios.post(`${data.apiUrl}`, data.body, {responseType: 'blob'});
    },
}